import eliteService from './../api/elite-service';
import redirect from '../uitls/redirect';
import { notifyError } from '../uitls/notification-helper';
import { MESSAGES } from '../uitls/messages';
import { HIDE_CHANNELS, MOVE_CHANNELS_BOTTOM } from '../uitls/constants';
import retry from '@/utils/retry';

const state = {
    videos: null,
    upcomingVideos: null,
    categoryVideos: null,
    isDashboardLoading: false,
    autocompleteSearchResults: [],
    searchVideoText: null,
};

const mutations = {
    setSearchText(state, search) {
        state.searchVideoText = search;
    },
    setVideos(state, videos) {
        const localuserInfo = JSON.parse(localStorage.getItem("userInfo"));
        const subscriptionInfo = localuserInfo?.corporate?.subscription;
        const isSubscribed = subscriptionInfo && !subscriptionInfo.is_free && subscriptionInfo.is_valid;
        state.videos = videos.map(video => ({
            ...video,
            isLocked: isSubscribed ?
                false
                : ("isSMBFree" in video ? !video.isSMBFree:true),
        }));
        //01-04-2021 ani asked for not listing elitefit/HPB videos in dashboard
        const lastIndexVideos = state.videos.filter(value => MOVE_CHANNELS_BOTTOM.includes(value.tenantName));
        state.videos = state.videos.filter(value => !([...MOVE_CHANNELS_BOTTOM,...HIDE_CHANNELS].includes(value.tenantName)));
        state.videos.push(...lastIndexVideos)
    },
    setUpcomingVideos(state, videos) {
        state.upcomingVideos = videos;
        //01-04-2021 ani asked for not listing elitefit/HPB videos in dashboard
        state.upcomingVideos = state.upcomingVideos.filter(value => !HIDE_CHANNELS.includes(value.tenantName));

    },
    setCategoryVideos(state, videos){
        state.categoryVideos = videos;
    },
    setLoading(state, loading) {
        state.isDashboardLoading = loading;
    },
    setAutocompleteSearchResults(state, autocompleteSearchResults) {
        state.autocompleteSearchResults = autocompleteSearchResults;
    }
};

const getters = {

};

const actions = {
    async loadVideos({ commit, dispatch }, data) {
        commit('setLoading', true);
        try {
            if(data === "No Data"){
                const videos = [];
                commit('setVideos', videos);
                commit('setLoading', false);  
                return videos;
            }else{
                const videos = await eliteService.getAllVideos(data);
                commit('setVideos', videos);
                commit('setLoading', false);  
                return videos;
            }
        } catch (e) {
            try {
                await retry(e);
                const videos = await eliteService.getAllVideos(data);
                commit('setVideos', videos);
                commit('setLoading', false);
                return videos;
            } catch {
                redirect(e);
                notifyError(MESSAGES.LOAD_VIDEO_FAILED);
                Promise.reject(e);
            }
            commit('setLoading', false);
        }
    },
    async loadUpcoming({ commit }) {
        commit('setLoading', true);
        try {
            const videos = await eliteService.getUpcomingVideos();
            commit('setUpcomingVideos', videos);
            commit('setLoading', false);
            return videos;
        }
        catch (e) {
            try {
                await retry(e);
                const videos = await eliteService.getUpcomingVideos();
                commit('setUpcomingVideos', videos);
                commit('setLoading', false);
                return videos;
            } catch {
                redirect(e);
                notifyError(MESSAGES.LOAD_VIDEO_FAILED);
                Promise.reject(e);
            }
        }
        commit('setLoading', false);
    },
    async loadCategoriesVideos({commit},id){
        commit('setLoading', true);
        try {
            const videos = await eliteService.getCategoriesVideos(id);
            commit('setCategoryVideos', videos);
            commit('setLoading', false);
            return videos;
        }
        catch (e) {
            redirect(e);
            notifyError(MESSAGES.LOAD_VIDEO_FAILED);
            Promise.reject(e);
        }
        commit('setLoading', false);
    },
    async fetchAutocompleteSearchResults({commit}, query) {
        try {
            const url = `${process.env.VUE_APP_API_URL}/title-search/autocomplete/${query}`;
            let res = await fetch(url, {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'ef-client-type': 'web',
                    'authorization': eliteService._getAuth()
                }
            });
            let data;
            if (res.status == 200) {
                data = await res.json();
                commit('setAutocompleteSearchResults', data);
            }
            else if (res.status == 401) {
                setTimeout(async () => {
                    res = await fetch(url, {
                        method: "GET",
                        headers: {
                            'Content-Type': 'application/json',
                            'ef-client-type': 'web',
                            'authorization': eliteService._getAuth()
                        }
                    });
                    if (res.status == 200)
                        data = await res.json();
                        commit('setAutocompleteSearchResults', data);
                }, 1000);
            } else return Promise.reject(await res.json());
            
        } catch (error) {
            notifyError("Failed to fetch search results");
            Promise.reject(error);
        }
    }
};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {

    }
}